import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-restart.tsx
/**
* icon.24.restart
*
* Keywords: arrow, counterclockwise, rotate, undo, revert, refresh, left, circular
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNOC44NTQgNS44NTRhLjUuNSAwIDEgMC0uNzA4LS43MDhsLTMgM2EuNS41IDAgMCAwIDAgLjcwOGwzIDNhLjUuNSAwIDAgMCAuNzA4LS43MDhMNi43MDcgOUgxNGE0IDQgMCAxIDEtMy43NDggNS40LjU2LjU2IDAgMCAwLS41MTYtLjM3N2MtLjMyNiAwLS41Ny4zLS40NjQuNjA4QTUuMDAyIDUuMDAyIDAgMCAwIDE5IDEzYTUgNSAwIDAgMC00Ljk5OC01SDYuNzA3eiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-1330
*/
const Icon24Restart = memo(function Icon24Restart(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M8.854 5.854a.5.5 0 1 0-.708-.708l-3 3a.5.5 0 0 0 0 .708l3 3a.5.5 0 0 0 .708-.708L6.707 9H14a4 4 0 1 1-3.748 5.4.56.56 0 0 0-.516-.377c-.326 0-.57.3-.464.608A5.002 5.002 0 0 0 19 13a5 5 0 0 0-4.998-5H6.707z",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24Restart };

//# sourceMappingURL=icon-24-restart.js.map